/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Field
 */
export interface Field {
    /**
     * URL-safe machine identifier for this field
     * @type {string}
     * @memberof Field
     */
    name: string;
    /**
     * Human-readable label displayed in the booking form
     * @type {string}
     * @memberof Field
     */
    title: string;
    /**
     * Helper text shown below the field in the booking form
     * @type {string}
     * @memberof Field
     */
    description: string;
    /**
     * The input type for this field
     * @type {string}
     * @memberof Field
     */
    type: FieldTypeEnum;
    /**
     * Whether this field is required to complete a booking
     * @type {boolean}
     * @memberof Field
     */
    required: boolean;
}


/**
 * @export
 */
export const FieldTypeEnum = {
    String: 'STRING',
    Text: 'TEXT',
    Boolean: 'BOOLEAN',
    Email: 'EMAIL',
    Phone: 'PHONE'
} as const;
export type FieldTypeEnum = typeof FieldTypeEnum[keyof typeof FieldTypeEnum];


/**
 * Check if a given object implements the Field interface.
 */
export function instanceOfField(value: object): value is Field {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function FieldFromJSON(json: any): Field {
    return FieldFromJSONTyped(json, false);
}

export function FieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): Field {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'description': json['description'],
        'type': json['type'],
        'required': json['required'],
    };
}

export function FieldToJSON(json: any): Field {
    return FieldToJSONTyped(json, false);
}

export function FieldToJSONTyped(value?: Field | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'title': value['title'],
        'description': value['description'],
        'type': value['type'],
        'required': value['required'],
    };
}

